(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["location-consent-popup"]) return;
  try {
    
  (() => {
    const consentKey = 'nutu-location-consent-v1';

    document.querySelectorAll('.js-location-consent').forEach((component) => {
      const overlay = component.querySelector('[data-location-overlay]');
      const dialog = component.querySelector('.location-consent__dialog');
      const title = component.querySelector('[data-location-title]');
      const body = component.querySelector('[data-location-body]');
      const cta = component.querySelector('[data-location-cta]');
      const countryInput = component.querySelector('#LocationConsentEnglishForm-' + component.id.replace('LocationConsentPopup-', '') + ' [name="country_code"]');
      const stayForm = component.querySelector('#LocationConsentStayForm-' + component.id.replace('LocationConsentPopup-', ''));
      const manualCountry = component.querySelector('[data-location-country]');
      const manualLanguage = component.querySelector('[data-location-language]');
      const primaryLanguage = component.querySelector('#LocationConsentEnglishForm-' + component.id.replace('LocationConsentPopup-', '') + ' [name="language_code"]');
      const isForcedPreview = new URLSearchParams(window.location.search).get('location-popup-preview') === '1';
      const isDesignMode = component.dataset.designMode === 'true';
      let countries = {};

      try {
        countries = JSON.parse(component.querySelector('[data-location-countries]').textContent);
      } catch (error) {
        return;
      }

      const rememberChoice = () => window.localStorage.setItem(consentKey, '1');
      const availableLanguages = new Set(Array.from(manualLanguage.options, (option) => option.value));
      const german = new Set(['DE', 'AT', 'LI']);
      const french = new Set(['FR', 'MC', 'GF', 'GP', 'MQ', 'RE', 'BL', 'MF', 'PM', 'NC', 'PF', 'WF', 'YT', 'BF', 'BJ', 'CD', 'CF', 'CG', 'CI', 'DJ', 'GA', 'GN', 'ML', 'NE', 'SN', 'TD']);
      const spanish = new Set(['ES', 'AR', 'BO', 'CL', 'CO', 'CR', 'DO', 'EC', 'GT', 'HN', 'MX', 'NI', 'PA', 'PE', 'PY', 'SV', 'UY', 'VE']);
      const multilingual = new Set(['BE', 'LU', 'CH', 'CA', 'CM', 'HT', 'BI', 'RW', 'KM', 'VU', 'MU', 'SC', 'DZ', 'MA', 'TN']);
      const browserLanguage = (navigator.language || '').split('-')[0].toLowerCase();
      const suggestedLanguage = (countryCode) => {
        let language = 'en';
        if (german.has(countryCode)) language = 'de';
        else if (french.has(countryCode)) language = 'fr';
        else if (spanish.has(countryCode)) language = 'es';
        else if (multilingual.has(countryCode)) {
          if (browserLanguage === 'fr') language = 'fr';
          if (browserLanguage === 'de' && ['BE', 'LU', 'CH'].includes(countryCode)) language = 'de';
        }
        return availableLanguages.has(language) ? language : 'en';
      };
      const messages = {
        en: { title: (country) => `Shopping from ${country}?`, body: (currency) => `Switch to our English store and shop in ${currency}. You can change your country or language at any time.`, cta: (currency) => `SHOP IN ENGLISH · ${currency}` },
        de: { title: (country) => `Einkauf aus ${country}?`, body: (currency) => `Wechsle zum deutschen Shop und kaufe in ${currency} ein. Land und Sprache kannst du jederzeit ändern.`, cta: (currency) => `AUF DEUTSCH EINKAUFEN · ${currency}` },
        fr: { title: (country) => `Vous achetez depuis ${country} ?`, body: (currency) => `Passez à la boutique en français et achetez en ${currency}. Vous pouvez changer de pays ou de langue à tout moment.`, cta: (currency) => `ACHETER EN FRANÇAIS · ${currency}` },
        es: { title: (country) => `¿Compras desde ${country}?`, body: (currency) => `Entra en la tienda en español y compra en ${currency}. Puedes cambiar de país o idioma cuando quieras.`, cta: (currency) => `COMPRAR EN ESPAÑOL · ${currency}` }
      };
      const configure = (countryCode) => {
        const country = countries[countryCode];

        if (!country) return false;

        const language = suggestedLanguage(countryCode);
        const copy = messages[language];
        const countryName = new Intl.DisplayNames([language], { type: 'region' }).of(countryCode) || country.name;
        title.textContent = copy.title(countryName);
        body.textContent = copy.body(country.currency);
        cta.textContent = copy.cta(country.currency);
        countryInput.value = countryCode;
        primaryLanguage.value = language;
        manualCountry.value = countryCode;
        manualLanguage.value = language;
        return true;
      };

      const displayNames = new Intl.DisplayNames(['en'], { type: 'region' });
      manualCountry.querySelectorAll('option').forEach((option) => {
        const country = countries[option.value];
        if (!country) return;
        option.textContent = `${displayNames.of(option.value) || country.name} (${country.currency})`;
      });
      manualCountry.addEventListener('change', () => {
        if (countries[manualCountry.value]) manualLanguage.value = suggestedLanguage(manualCountry.value);
      });

      const open = () => {
        overlay.hidden = false;
        document.documentElement.classList.add('location-consent-open');
        dialog.focus();
      };

      component.querySelectorAll('[data-location-choice]').forEach((button) => {
        button.addEventListener('click', rememberChoice);
      });

      component.querySelector('[data-location-close]').addEventListener('click', () => {
        rememberChoice();
        stayForm.requestSubmit();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !overlay.hidden) {
          rememberChoice();
          stayForm.requestSubmit();
        }
      });

      if (isForcedPreview || isDesignMode) {
        if (configure(countries.DE ? 'DE' : Object.keys(countries).find((code) => code !== 'PL'))) open();
        return;
      }

      if (window.localStorage.getItem(consentKey)) return;

      const currentCountry = window.Shopify && window.Shopify.country ? window.Shopify.country : 'PL';
      const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      const endpoint = `${root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${encodeURIComponent(currentCountry)}&language[enabled]=true`;

      fetch(endpoint, { credentials: 'same-origin' })
        .then((response) => response.ok ? response.json() : null)
        .then((data) => {
          const suggestion = data && data.suggestions && data.suggestions[0] && data.suggestions[0].parts && data.suggestions[0].parts.country;
          const detected = data && data.detected_values && data.detected_values.country;
          const countryCode = (suggestion && suggestion.handle) || (detected && detected.handle);

          if (countryCode && countryCode !== 'PL' && configure(countryCode)) open();
        })
        .catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perfume-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.js-perfume-quiz');
    if (!root) return;

    const form = root.querySelector('[data-quiz-form]');
    const step = root.querySelector('[data-quiz-step]');
    const progress = root.querySelector('[data-quiz-progress]');
    const back = root.querySelector('[data-quiz-back]');
    const next = root.querySelector('[data-quiz-next]');
    const custom = root.querySelector('[data-quiz-custom]');
    const note = root.querySelector('[data-quiz-note]');
    const error = root.querySelector('[data-quiz-error]');
    const loading = root.querySelector('[data-quiz-loading]');
    const result = root.querySelector('[data-quiz-result]');
    const supportedLanguages = ['pl', 'en', 'de', 'fr', 'es'];
    const requestedLanguage = (root.dataset.language || '').toLowerCase();
    const language = supportedLanguages.includes(requestedLanguage) ? requestedLanguage : 'en';
    const translations = {
      pl: {
        progress: 'Pytanie {current} z {total}', next: 'Dalej', submit: 'Pokaż moje dopasowania',
        required: 'Wybierz jedną odpowiedź, aby przejść dalej.', failed: 'Coś poszło nie tak. Spróbuj ponownie.',
        notePrefix: 'Dodatkowa wskazówka klienta:',
        prompt: 'Ukończyłem/ukończyłam quiz zapachowy. Zaproponuj maksymalnie trzy eliksiry NOUS TOUS wyłącznie na podstawie katalogu. Przy każdym krótko wyjaśnij, dlaczego pasuje, kiedy go nosić, a link do każdego produktu podaj w osobnej linii.',
        questions: [
          ['Kiedy najczęściej chcesz go nosić?', ['Na co dzień', 'Do biura lub na uczelnię', 'Na randkę lub wieczorne wyjście', 'Na wyjątkowe okazje']],
          ['W którą stronę zapachową idziesz?', ['Świeżo i czysto', 'Słodko i otulająco', 'Ciepło, przyprawowo lub drzewnie', 'Kwiatowo i elegancko']],
          ['Jak bardzo ma być wyczuwalny?', ['Blisko skóry', 'Wyraźny, ale zbalansowany', 'Mocny i robiący wrażenie']],
          ['Czego szukasz?', ['Bezpiecznego i uniwersalnego wyboru', 'Czegoś charakternego', 'Zaskocz mnie']]
        ]
      },
      en: {
        progress: 'Question {current} of {total}', next: 'Next question', submit: 'Show my matches',
        required: 'Choose one answer to continue.', failed: 'Something went wrong. Please try again.',
        notePrefix: 'Additional customer note:',
        prompt: 'I completed the fragrance quiz. Recommend no more than three NOUS TOUS elixirs based only on the catalog. Explain briefly why each suits me, when to wear it, and put every product link on a separate line.',
        questions: [
          ['When will you wear it most often?', ['Every day', 'Office or university', 'Date or evening out', 'Special occasions']],
          ['Which direction sounds best?', ['Fresh and clean', 'Sweet and comforting', 'Warm, spicy or woody', 'Floral and elegant']],
          ['How noticeable should it be?', ['Close to the skin', 'Noticeable but balanced', 'Strong and statement-making']],
          ['What kind of scent are you looking for?', ['Something safe and versatile', 'Something distinctive', 'Surprise me']]
        ]
      },
      de: {
        progress: 'Frage {current} von {total}', next: 'Nächste Frage', submit: 'Meine Treffer anzeigen',
        required: 'Wähle eine Antwort aus, um fortzufahren.', failed: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
        notePrefix: 'Zusätzlicher Hinweis:',
        prompt: 'Ich habe das Duftquiz abgeschlossen. Empfiehl mir höchstens drei NOUS TOUS Elixiere ausschließlich auf Grundlage des Katalogs. Erkläre kurz, warum jeder Duft zu mir passt, wann ich ihn tragen sollte, und setze jeden Produktlink in eine eigene Zeile.',
        questions: [
          ['Wann möchtest du den Duft am häufigsten tragen?', ['Im Alltag', 'Im Büro oder an der Universität', 'Bei einem Date oder abends', 'Zu besonderen Anlässen']],
          ['Welche Duftrichtung gefällt dir am besten?', ['Frisch und sauber', 'Süß und umhüllend', 'Warm, würzig oder holzig', 'Blumig und elegant']],
          ['Wie präsent soll der Duft sein?', ['Nah an der Haut', 'Wahrnehmbar, aber ausgewogen', 'Kräftig und ausdrucksstark']],
          ['Was suchst du?', ['Etwas Sicheres und Vielseitiges', 'Etwas Charaktervolles', 'Überrasche mich']]
        ]
      },
      fr: {
        progress: 'Question {current} sur {total}', next: 'Question suivante', submit: 'Voir mes sélections',
        required: 'Choisissez une réponse pour continuer.', failed: 'Une erreur est survenue. Veuillez réessayer.',
        notePrefix: 'Indication supplémentaire :',
        prompt: 'J’ai terminé le quiz parfum. Recommande-moi au maximum trois élixirs NOUS TOUS en te basant uniquement sur le catalogue. Explique brièvement pourquoi chacun me correspond, quand le porter, et place chaque lien produit sur une ligne séparée.',
        questions: [
          ['Quand le porterez-vous le plus souvent ?', ['Au quotidien', 'Au bureau ou à l’université', 'Pour un rendez-vous ou une soirée', 'Pour les grandes occasions']],
          ['Quelle direction olfactive vous attire le plus ?', ['Fraîche et propre', 'Douce et enveloppante', 'Chaude, épicée ou boisée', 'Florale et élégante']],
          ['Quelle présence recherchez-vous ?', ['Près de la peau', 'Présente mais équilibrée', 'Intense et affirmée']],
          ['Que recherchez-vous ?', ['Un choix sûr et polyvalent', 'Quelque chose de singulier', 'Surprenez-moi']]
        ]
      },
      es: {
        progress: 'Pregunta {current} de {total}', next: 'Siguiente pregunta', submit: 'Ver mis resultados',
        required: 'Elige una respuesta para continuar.', failed: 'Algo ha salido mal. Inténtalo de nuevo.',
        notePrefix: 'Nota adicional:',
        prompt: 'He completado el quiz de fragancias. Recomiéndame como máximo tres elixires NOUS TOUS basándote únicamente en el catálogo. Explica brevemente por qué encaja cada uno conmigo, cuándo llevarlo y coloca cada enlace de producto en una línea separada.',
        questions: [
          ['¿Cuándo la llevarás con más frecuencia?', ['A diario', 'En la oficina o la universidad', 'En una cita o una salida nocturna', 'En ocasiones especiales']],
          ['¿Qué dirección olfativa te atrae más?', ['Fresca y limpia', 'Dulce y envolvente', 'Cálida, especiada o amaderada', 'Floral y elegante']],
          ['¿Qué presencia quieres que tenga?', ['Cerca de la piel', 'Perceptible pero equilibrada', 'Intensa y con carácter']],
          ['¿Qué estás buscando?', ['Una opción segura y versátil', 'Algo distintivo', 'Sorpréndeme']]
        ]
      }
    };
    const texts = translations[language];
    const answers = [];
    let index = 0;

    const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[char]));
    const renderReply = (value) => escapeHtml(value).replace(/\[([^\]]+)\]\(([^)]+)\)/g, (match, label, url) => {
      const href = url.trim();
      const relativeProduct = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^\s]+$/i.test(href);
      const storeProduct = /^https:\/\/(?:www\.)?nutu\.store\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^\s]+$/i.test(href);
      return relativeProduct || storeProduct ? `<a href="${href}" target="_self">${label}</a>` : label;
    }).replace(/\n/g, '<br>');

    const renderQuestion = () => {
      const [question, options] = texts.questions[index];
      progress.textContent = texts.progress.replace('{current}', index + 1).replace('{total}', texts.questions.length);
      step.innerHTML = `<legend class="perfume-quiz__question">${question}</legend>${options.map((option, optionIndex) => `<label class="perfume-quiz__option"><input type="radio" name="quiz-${index}" value="${option}"${answers[index] === option ? ' checked' : ''}><span>${option}</span></label>`).join('')}`;
      custom.hidden = index !== texts.questions.length - 1;
      back.hidden = index === 0;
      next.textContent = index === texts.questions.length - 1 ? texts.submit : texts.next;
      error.hidden = true;
    };

    back.addEventListener('click', () => { index -= 1; renderQuestion(); });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const selected = step.querySelector('input:checked');
      if (!selected) { error.textContent = texts.required; error.hidden = false; return; }
      answers[index] = selected.value;
      if (index < texts.questions.length - 1) { index += 1; renderQuestion(); return; }

      form.hidden = true;
      loading.hidden = false;
      const details = texts.questions.map(([question], answerIndex) => `${question}: ${answers[answerIndex]}`).join('\n');
      const noteValue = note.value.trim();
      const message = `${texts.prompt}\n\n${details}${noteValue ? `\n${texts.notePrefix} ${noteValue}` : ''}`;
      const controller = new AbortController();
      const timeoutId = window.setTimeout(() => controller.abort(), 25000);
      try {
        const response = await fetch(root.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ messages: [{ role: 'user', content: message }], lang: language, turnCount: 0 }),
          signal: controller.signal
        });
        let data;
        try { data = await response.json(); } catch { data = {}; }
        const reply = typeof data.reply === 'string' ? data.reply.trim() : '';
        if (!response.ok || !reply) throw new Error('Invalid advisor response');
        result.innerHTML = renderReply(reply);
        result.hidden = false;
      } catch (requestError) {
        form.hidden = false;
        error.textContent = texts.failed;
        error.hidden = false;
      } finally {
        window.clearTimeout(timeoutId);
        loading.hidden = true;
      }
    });

    renderQuestion();
  })();

  } catch(e) { console.error(e); }
})();
})();
